/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-shadow */
import { useCallback, useEffect, useState } from "react";
import {
  Chip,
  Stack,
  Tab,
  Tabs,
  Typography,
  FormControl,
  TextField,
  Box,
  Button,
  Grid,
  Checkbox,
} from "@mui/material";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { useNavigate, useParams } from "react-router-dom";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import IconComponent from "app/shared-components/IconComponent";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import jwtDecode from "jwt-decode";
import AgGridTable from "../utilities/AgGridTable";
import FormPageHeader from "../utilities/FormPageHeader";

const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.role}`;
const privilegesUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.privileges}`;
const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

export default function EditRole({ data }) {
  const [error, setError] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [roleInitName, setRoleInitName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [privileges, setPrivileges] = useState([]);
  const [userPrivileges, setUserPrivileges] = useState([]);
  const [userInitPrivileges, setUserInitPrivileges] = useState([]);
  const [checkSubmit, setCheckSubmit] = useState(false);
  const params = useParams();
  const [validError, setValidError] = useState({});
  const navigate = useNavigate();
  const [saveDisable, setSaveDisable] = useState(true);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [hideDelete, setHideDelete] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [allPrivilege, setAllPrivilege] = useState([]);
  const [checked, setChecked] = useState([]);

  const [columnDefs, setColumnDefs] = useState([
    { field: "name" },
    { field: "roles" },
    { field: "email" },
    { field: "active", cellRenderer: IconComponent },
  ]);

  const getPrivilegeData = (allPrivilege = [], privilegesID = "") => {
    const data = allPrivilege.find((item) => {
      const id = item?._links?.privilege?.href.split("/").pop();
      return id === privilegesID;
    });
    return data?.displayName || privilegesID;
  };
  
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };
  const GetRole = async (allPrivilege) => {
    try {
      const result = await OAuthService.getEditData(url, params.id);
      const { data } = result;
      setRoleName(data.displayName);
      setRoleInitName(data.displayName);
      setRoleId(data?._links?.role?.href.split("/").pop());
      if (Array.isArray(data.privileges)) {
        const privilege = data.privileges.map((privilege) =>
          getPrivilegeData(allPrivilege, privilege)
        );
        setUserPrivileges(privilege);
        setUserInitPrivileges(privilege)
        setFilteredList((prev) =>
          prev.filter((item) => !privilege.includes(item))
        );
        setPrivileges((prev) =>
          prev.filter((item) => !privilege.includes(item))
        );
      }
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    }
  };

  const getPrivilegeId = (privilegeNames = []) => {
    return allPrivilege
      .map((item) => {
        if (privilegeNames.includes(item.displayName)) {
          return item?._links?.privilege?.href.split("/").pop();
        }
        return false;
      })
      .filter(Boolean);
  };

  const loadPrivileges = async () => {
    try {
      const list = await OAuthService.getList(`${privilegesUrl}?size=1000`);
      const privileges = list.data?._embedded?.privileges;
      setAllPrivilege(privileges);
      setFilteredList(privileges.map((item) => item.displayName));
      setPrivileges(privileges.map((item) => item.displayName));
      if (params.id) {
        GetRole(privileges);
        setHideDelete(false);
        // loadPrivileges();
      }
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    }
  };

  useEffect(() => {
    // GetRole();
    loadPrivileges();
  }, [params.id]);

  useEffect(() => { }, [params.id]);

  function dropHandler(ev, box) {
    ev.preventDefault();
    const data = ev.dataTransfer.getData("text/plain");
    const id = data.split("-").pop();

    if (box === "container-right") {
      setUserPrivileges((prev) => [...prev, id]);
      setFilteredList((prev) => prev.filter((item) => item !== id));
      setPrivileges((prev) => prev.filter((item) => item !== id));
    } else {
      setUserPrivileges((prev) => prev.filter((item) => item !== id));
      setFilteredList((prev) => [id, ...prev]);
      setPrivileges((prev) => [id, ...prev]);
    }
  }
  const handleDeleteIcon = async (name) => {
    setUserPrivileges((prev) => prev.filter((item) => item !== name));
    setFilteredList((prev) => [name, ...prev]);
    setPrivileges((prev) => [name, ...prev]);
  };
  function dragStartHandler(ev) {
    ev.dataTransfer.setData("text/plain", ev.target.id);
    ev.dataTransfer.effectAllowed = "move";
  }
  function dragOverHandler(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = "move";
  }

  const handleSubmit = async () => {
    setCheckSubmit(true);
    const payload = {
      name: roleId ? roleId : `${roleName}`.toUpperCase(),
      displayName: roleName,
      privileges: getPrivilegeId(userPrivileges),
    };
    setValidError({ ...validError });
    if (userPrivileges)
      try {
        if (params.id) {
          await OAuthService.updateData(url, params.id, payload);
          setTimeout(() => {
            navigate("/roles");
          }, 800);
        } else {
          if (
            roleName &&
            !validError?.roleName &&
            roleId &&
            !validError?.roleId
          ) {
            await OAuthService.addData(url, payload);
            setTimeout(() => {
              navigate("/roles");
            }, 800);
          }
        }
      } catch (error) {
        setError(error.message);
      }
  };

  const handleDelete = async () => {
    try {
      if (params.id) {
        await OAuthService.deleteData(url, params.id);
        setSuccessMsg("Data deleted Successfully");
        setSnackState(true);
      }
    } catch (error) {
      console.log("error", error);
      setError(error.message);
      return;
    }
    setTimeout(() => {
      navigate("/roles");
    }, 800);
  };

  const handleCancel = () => {
    navigate("/roles");
  };

  useEffect(() => {
    const isSame = JSON.stringify(userPrivileges.sort((a, b) => (a < b ? -1 : 1))) === JSON.stringify(userInitPrivileges.sort((a, b) => (a < b ? -1 : 1)))
    const isSameRoleName = roleName === roleInitName
    setSaveDisable(isSame && isSameRoleName);
  }, [userPrivileges, roleName]);

  function handleTabChange(event, value) {
    setTabValue(value);
  }

  const users = async () => {
    if (params.id) {
      const users = await OAuthService.getList(
        `${userUrl}?sort=firstName,asc&size=1000`
      );
      const userList = users.data?._embedded.users.map((data, key) => {
        data.name = `${data.firstName} ${data.lastName}`;
        return data;
      });
      const getRoleUserList = userList.filter((item) => {
        if (item?.roles?.includes(params.id)) {
          return item;
        }
      });
      setRowData(getRoleUserList);
    }
  };

  const onGridReady = useCallback((params) => {
    users();
  }, []);

  const token = jwtDecode(localStorage.getItem("token"));

  const [filteredList, setFilteredList] = useState("");

  const filterBySearch = (event) => {
    const query = event.target.value;
    let updatedList = [...privileges];
    if (query) {
      updatedList = updatedList.filter((item) => {
        return item.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    }
    setFilteredList(updatedList);
  };

  const leftChecked = checked.filter((value) => filteredList.includes(value));
  const rightChecked = checked.filter((value) => userPrivileges.includes(value));

  function sortFunc(results, sortType) {
    if (sortType === "ascending") {
      results.sort((a, b) => (a < b ? -1 : 1));
    } else if (sortType === "descending") {
      results.sort((a, b) => (b > a ? 1 : -1));
    } else {
      results = [...privileges];
    }
    return results;
  }

  const [selectedSort, setSelectedSort] = useState({
    value: "default",
    label: "None",
  });

  const sortOptions = [
    { value: "default", label: "None" },
    { value: "ascending", label: "Ascending" },
    { value: "descending", label: "Descending" },
  ];

  const handleSortChange = (data) => {
    setSelectedSort(data);
    setFilteredList(sortFunc([...privileges], data.value));
  };

  const handleMoveAllRight = () => {
    const privileges = [...filteredList,...userPrivileges];
    setUserPrivileges(privileges);
    setFilteredList([]);
  }

  const handleMoveSelectedRight = () => {
    const privileges = [...leftChecked, ...userPrivileges];
    setUserPrivileges(privileges);

    const list = filteredList.filter((item) => !leftChecked.includes(item));
    setFilteredList(list);
    setChecked(checked.filter((item) => !leftChecked.includes(item)));
  }
  const handleMoveSelectedLeft = () => {
    const list = [...rightChecked, ...filteredList];
    setFilteredList(list);

    const privileges = userPrivileges.filter((item) => !rightChecked.includes(item));
    setUserPrivileges(privileges);
    setChecked(
      checked.filter((item) => !rightChecked.includes(item))
    );
  }
  const handleMoveAllLeft = () => {
    const list = [...userPrivileges,...filteredList];
    setFilteredList(list);
    setUserPrivileges([]);
  }

  return (
    <>
      <FormPageHeader
        componentName="Role"
        pageName="Update Role"
        handleSubmit={handleSubmit}
        error={error}
        saveDisable={saveDisable}
        currentPage={params.id ? "Update Role" : "Add Role"}
        // handleDelete={token?.scope?.includes('ROLE_ADMIN') ? handleDelete : ''}
        parentBreadcrumbData={[{ pageName: "Roles List", pageLink: "/roles" }]}
        successMsg={successMsg}
        snackState={snackState}
        // hideDelete={hideDelete}
        handleCancel={handleCancel}
      >
       <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
        >
          <Tab 
            label="General" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          {params.id && (
            <Tab 
              label="User" 
              sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
            />
          )}
        </Tabs>
      </FormPageHeader>
      <div className="p-16 sm:p-24 overflow-scroll">
        <FormControl className="flex flex-col justify-center">
          <div className={tabValue !== 0 ? "hidden" : ""}>
            <div className="max-w-3xl">
              <Stack>
                <label>
                  *Role ID
                </label>
                <TextField
                  className="mb-4"
                  type="text"
                  value={roleId}
                  required
                  disabled={params.id && true}
                  variant="outlined"
                  fullWidth
                  onChange={(e) => {
                    setRoleId(
                     e.target.value.replace(/[^a-z_]/gi, "").toUpperCase()
                    );
                    setValidError({ ...validError });
                  }}
                  error={!!((checkSubmit && !roleId) || validError.roleId)}
                  helperText={
                    checkSubmit && !roleId
                      ? "Enter only alphabets"
                      : validError.roleId
                  }
                  sx={params.id ? { 
                    backgroundColor: 'action.disabledBackground',
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: (theme) => theme.palette.text.primary,
                    }
                  } : {}}
                />
              </Stack>
              <Stack mt={1.5}>
                <label>*Role Name</label>
                <TextField
                  className="mb-4"
                  type="text"
                  value={roleName}
                  required
                  variant="outlined"
                  fullWidth
                  onChange={(e) => {
                    setRoleName(e.target.value.toUpperCase());
                    setValidError({ ...validError });
                  }}
                  error={!!((checkSubmit && !roleName) || validError.roleName)}
                  helperText={
                    checkSubmit && !roleName
                      ? "This field is required"
                      : validError.roleName
                  }
                />
              </Stack>
              <div className="flex flex-col sm:flex-row flex-1 w-full items-center justify-between mt-10">
                <div>
                  <label>Privilege Selection</label>
                  <Box className="flex">
                    <TextField
                      className="mb-12"
                      type="text"
                      variant="outlined"
                      fullWidth
                      onChange={filterBySearch}
                      styles={customStyles()}
                      placeholder="Search Privileges..."
                      sx={{ marginRight: "10px", width: "230px" }}
                    />
                    <Box sx={{ width: "162px" }}>
                      <Select
                        required
                        value={selectedSort}
                        onChange={handleSortChange}
                        options={sortOptions}
                        styles={customStyles()}
                        className="w-full"
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: 400,
                      height: 300,
                      border: "2px solid grey",
                      overflowY: "auto",
                    }}
                    id="target"
                    onDrop={(event) => dropHandler(event, "container-left")}
                    onDragOver={(event) => dragOverHandler(event)}
                  >
                    {filteredList &&
                      filteredList.map((val) => {
                        return (
                          <div className="flex">
                            <Checkbox
                              checked={checked.indexOf(val) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{
                                "aria-labelledby": val
                              }}
                              onChange={handleToggle(val)} // Add onChange event handler
                            />
                            <Chip
                              label={val}
                              key={val}
                              id={`show-${val}`}
                              draggable
                              onDragStart={(event) =>
                                dragStartHandler(event, val)
                              }
                              color="primary"
                              sx={{
                                mt: 1,
                                mx: 1,
                                width: '100%',
                                borderRadius: 1,
                              }}
                            />
                          </div>
                        );
                      })}
                  </Box>
                </div>
                <div className="grid">
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleMoveAllRight}
                    disabled={filteredList.length === 0}
                    aria-label="move all right"
                  >
                    ≫
                  </Button>
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleMoveSelectedRight}
                    disabled={leftChecked.length === 0}
                    aria-label="move selected right"
                  >
                    &gt;
                  </Button>
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleMoveSelectedLeft}
                    disabled={rightChecked.length === 0}
                    aria-label="move selected left"
                  >
                    &lt;
                  </Button>
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleMoveAllLeft}
                    disabled={userPrivileges.length === 0}
                    aria-label="move all left"
                  >
                    ≪
                  </Button>
                </div>
                <div>
                  <label>*Selected Privilege</label>
                  <Box
                    sx={{
                      width: 300,
                      height: 300,
                      border: "2px solid grey",
                      overflowY: "auto",
                    }}
                    onDrop={(event) => dropHandler(event, "container-right")}
                    onDragOver={(event) => dragOverHandler(event)}
                  >
                    <div>
                      {userPrivileges &&
                        userPrivileges.map((val) => {
                          return (
                            <div className="flex">
                              <Checkbox
                                checked={checked.indexOf(val) !== -1}
                                tabIndex={-1}
                                disableRipple
                                inputProps={{
                                  "aria-labelledby": val
                                }}
                                onChange={handleToggle(val)} // Add onChange event handler
                              />
                              <Chip
                                label={val}
                                key={val}
                                id={`show-${val}`}
                                onDragStart={(event) =>
                                  dragStartHandler(event, val)
                                }
                                color="primary"
                                sx={{
                                  mt: 1,
                                  mx: 1,
                                  width: '100%',
                                  borderRadius: 1,
                                }}
                                onDelete={() => handleDeleteIcon(val)}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </Box>
                </div>
              </div>
              <Typography className="text-[#f44336] text-sm ml-14">
                {checkSubmit && userPrivileges.length === 0
                  ? "This field is required"
                  : ""}
              </Typography>
            </div>
          </div>
          <div className={tabValue !== 1 ? "hidden" : " h-full"}>
            <Grid
              className="flex flex-row mb-10"
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddCircleOutlineIcon />}
                onClick={(e) => navigate(`/addUser`)}
              >
                Add User
              </Button>
            </Grid>
            <Stack style={{ height: "400px" }}>
              <AgGridTable
                rowData={rowData}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
              />
            </Stack>
          </div>
        </FormControl>
      </div>
    </>
  );
}
